/**
 * SVG Icon collection
 */
import SVGContrastIcon from "./SVGContrastIcon";
import SVGDownTriangleIcon from "./SVGDownTriangleIcon";
import SVGFullscreenIcon from "./SVGFullscreenIcon";
import SVGLayerStackIcon from "./SVGLayerStackIcon";
import SVGLayoutIcon from "./SVGLayoutIcon";
import SVGLayoutTemplateIcon from "./SVGLayoutTemplateIcon";
import SVGMeasureIcon from "./SVGMeasureIcon";
import SVGMeasurementToolIcon from "./SVGMeasurementToolIcon";
import SVGOpenAddFolderIcon from "./SVGOpenAddFolderIcon";
import SVGPanIcon from "./SVGPanIcon";
import SVGSeriesIcon from "./SVGSeriesIcon";
import SVGUserIcon from "./SVGUserIcon";
import SVGZoomIcon from "./SVGZoomIcon";
import SVGWarningIcon from "./SVGWarningIcon";
import SVGSmallWarningIcon from "./SVGSmallWarningIcon";
import SVGToggleDicomTagIcon from "./SVGToggleDicomTagIcon";
import SVGInfoIcon from "./SVGInfoIcon";
import SVGLinkIcon from "./SVGLinkIcon";
import SVGLinkAutoIcon from "./SVGLinkAutoIcon";
import SVGLinkManualIcon from "./SVGLinkManualIcon";
import SVGLinkUnlinkIcon from "./SVGLinkUnlinkIcon";
import SVGUnlinkIcon from "./SVGUnlinkIcon";
import SVGDropdownCheckmarkIcon from "./SVGDropdownCheckmarkIcon";
import SVGSplitSeries1Icon from "./SVGSplitSeries1Icon";
import SVGSplitSeries2Icon from "./SVGSplitSeries2Icon";
import SVGImageFusionIcon from "./SVGImageFusionIcon";
import SVGMPRIcon from "./SVGMPRIcon";
import SVGSettingIcon from "./SVGSettingIcon";
/**
 * CSS Icon Collection
 */
import SVGCheckmarkIcon from "./SVGCheckmarkIcon";

const SVGIcon = {
  SVGContrastIcon,
  SVGDownTriangleIcon,
  SVGFullscreenIcon,
  SVGLayerStackIcon,
  SVGLayoutIcon,
  SVGLayoutTemplateIcon,
  SVGMeasureIcon,
  SVGMeasurementToolIcon,
  SVGOpenAddFolderIcon,
  SVGPanIcon,
  SVGSeriesIcon,
  SVGUserIcon,
  SVGZoomIcon,
  SVGWarningIcon,
  SVGSmallWarningIcon,
  SVGToggleDicomTagIcon,
  SVGInfoIcon,
  SVGCheckmarkIcon,
  SVGDropdownCheckmarkIcon,
  SVGLinkIcon,
  SVGLinkAutoIcon,
  SVGLinkManualIcon,
  SVGLinkUnlinkIcon,
  SVGUnlinkIcon,
  SVGSplitSeries1Icon,
  SVGSplitSeries2Icon,
  SVGImageFusionIcon,
  SVGMPRIcon,
  SVGSettingIcon,
};

export default SVGIcon;
